// api
import { fetchApi, showInfoDialog } from '@/api'
import router from '@/router'
// actions

const cafeteriaRequestsAllExternal = (context) => {
  let url = 'cafeteria/enlistment/external'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_REQUESTS_EXTERNAL_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const cafeteriaRequestsDispatch = (context, payload) => {
  // let obj = JSON.parse(payload)
  console.log('External', payload)
  let url = 'cafeteria/enlistment/' + payload.id
  var myJSON = JSON.stringify(payload)
  return fetchApi(url, myJSON, 'PUT')
    .then((response) => {
      context.commit('CAFETERIA_REQUESTS_EXTERNAL_ALL', response)
    })
    .catch((error) => {
      console.error(error)
    })
}

const cafeteriaRequestsAllReady = (context) => {
  let url = 'cafeteria/enlistment/turns'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_REQUESTS_EXTERNAL_TURNS', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restauranteRequestsAllReady = (context) => {
  let url = 'restaurant/turnero'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_REQUESTS_EXTERNAL_TURNS', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const papeleriaRequestsAllReady = (context) => {
  let url = 'papeleria/enlistment/turns'
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('CAFETERIA_REQUESTS_EXTERNAL_TURNS', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const validateCredential = (context, payload) => {
  let url = 'admin/carnets/' + payload + '/validate'
  let data = {}
  console.log(payload)
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('CAFETERIA_REQUESTS_VALIDATE', response)
    })
    .catch((error) => {
      console.error(error)
    })
}

const clearCredential = (context) => {
  return new Promise((resolve,reject)=>{
    resolve(context.commit('CREDENTIAL_CLEAR'))
  })
}


const validateCredentialCode = (context, payload) => {
  let url = 'admin/carnets/' + payload + '/validate'
  let data = {}
  console.log(payload)
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('CARNETS_REQUESTS_VALIDATE', response)
    })
    .catch((error) => {
      console.error(error)
    })
}
const validateCredentialCodediscount = (context, payload) => {
  let url = 'admin/carnets/' + payload + '/validate'
  let data = {}
  console.log(payload)
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('CARNETS_REQUESTS_VALIDATE_DISCOUNT', response)
    })
    .catch((error) => {
      console.error(error)
    })
}

const validateCredentialDispatch = (context, payload) => {
  let url = 'admin/carnets/' + payload + '/validatedispatch'
  let data = {}
  console.log(payload)
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('CAFETERIA_REQUESTS_EXTERNAL_DISPATCH', response)
    })
    .catch((error) => {
      console.error(error)
    })
}

const validatePapeleriaCredentialDispatch = (context, payload) => {
  let url = 'admin/carnets/' + payload + '/papeleria/validatedispatch'
  let data = {}
  console.log(payload)
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('CAFETERIA_REQUESTS_EXTERNAL_DISPATCH', response)
    })
    .catch((error) => {
      console.error(error)
    })
}

const getRequestFromUser = (context, payload) => {
  let url = 'cafeteria/requests/' + payload
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('CAFETERIA_REQUESTS_EXTERNAL_PRODUCTS', response)
    })
    .catch((error) => {
      console.error(error)
    })
}

const getRequestPapeleriaFromUser = (context, payload) => {
  let url = 'papeleria/requests/' + payload
  let data = {}
  return fetchApi(url, data, 'GET')
    .then((response) => {
      context.commit('PAPELERIA_REQUESTS_EXTERNAL_PRODUCTS', response)
    })
    .catch((error) => {
      console.error(error)
    })
}

const externalDispatchProduct = (context, payload) => {
  let url = 'cafeteria/requests/dispatch'
  var myJSON = JSON.stringify(payload)
  return fetchApi(url, myJSON, 'POST')
    .then((response) => {
      if(!response.code){
        showInfoDialog(
          "Mensaje informativo",
          response.message,
          "Aceptar"
        );
      }
    }).catch((error) => {
      console.log(error)
    })
}

const externalDispatchPapeleriaProduct = (context, payload) => {
  let url = 'papeleria/requests/dispatch'
  var myJSON = JSON.stringify(payload)
  return fetchApi(url, myJSON, 'POST')
    .then((response) => {
      //alert('Producto entregado')
    }).catch((error) => {
      console.log(error)
    })
}

export default {
  cafeteriaRequestsAllExternal,
  cafeteriaRequestsDispatch,
  cafeteriaRequestsAllReady,
  validateCredential,
  validateCredentialDispatch,
  getRequestFromUser,
  getRequestPapeleriaFromUser,
  externalDispatchProduct,
  externalDispatchPapeleriaProduct,
  validateCredentialCode,
  clearCredential,
  papeleriaRequestsAllReady,
  validatePapeleriaCredentialDispatch,
  validateCredentialCodediscount,
  restauranteRequestsAllReady
}



// WEBPACK FOOTER //
// ./src/store/modules/external/actions.js